import { render, staticRenderFns } from "./Detailtabs.vue?vue&type=template&id=21bff9de"
import script from "./Detailtabs.vue?vue&type=script&lang=js"
export * from "./Detailtabs.vue?vue&type=script&lang=js"
import style0 from "./Detailtabs.vue?vue&type=style&index=0&id=21bff9de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports